/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:39e717ef-d4a9-496c-9728-dfc1f1d7406f",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_q4RAe12uS",
    "aws_user_pools_web_client_id": "6fc1pmvkqfgcj1d76h9ad4mu2q",
    "sso_auth_key": "",
    "oauth": {},
    "aws_content_delivery_bucket": "cb911-demo-us-east-1-website",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://cb911-demo.merchant-dispute.com"
};


export default awsmobile;
